import { Injectable } from '@angular/core';
import { SiteApiService } from '@services';

@Injectable({
    providedIn: 'root',
})
export class StyleAppHelper {
    public logoUrl: string;

    constructor(private siteApiService: SiteApiService) {}

    loadStyles(): Promise<boolean> {
        return new Promise((resolve) => {
            this.siteApiService.getAppSettings().subscribe(
                (response) => {
                    let colors = {};
                    response.forEach((setting: any) => {
                        if (setting.setting_type === 'colour') {
                            colors[setting.key] = setting.value;
                        }
                        if (setting.setting_type === 'image') {
                            this.logoUrl = setting.associated_image;
                        }
                    });
                    this.setCSSVars(colors);
                    this.defineAlphaScale(
                        colors['ow-color-primary'],
                        colors['ow-color-white']
                    );
                    resolve(true);
                },
                (error) => {
                    console.log(error);
                    resolve(false);
                }
            );
        });
    }

    getLogoUrl(): string {
        return this.logoUrl;
    }

    /**
     * json to css vars
     * @param json
     */
    setCSSVars(json: object) {
        Object.entries(json).forEach(([key, value]) => {
            document.body.style.setProperty(`--remote-${key}`, value);
        });
    }

    hexToRgb(hex: string): any {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16),
              }
            : null;
    }

    componentToHex(c: number): string {
        const hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    rgbToHex(r: number, g: number, b: number): string {
        return (
            '#' +
            this.componentToHex(r) +
            this.componentToHex(g) +
            this.componentToHex(b)
        );
    }

    defineAlphaScale(
        color1: string,
        color2: string,
        opacities: number[] = [75, 50, 25, 15, 10, 5],
        prefix: string = 'remote-ow-color-base'
    ): void {
        const objColor1 = this.hexToRgb(color1);
        const objColor2 = this.hexToRgb(color2);
        opacities.map((opacity) => {
            const red = Math.floor(
                objColor2.r +
                    (objColor1.r - objColor2.r) * ((100 - opacity) / 100)
            );
            const green = Math.floor(
                objColor2.g +
                    (objColor1.g - objColor2.g) * ((100 - opacity) / 100)
            );
            const blue = Math.floor(
                objColor2.b +
                    (objColor1.b - objColor2.b) * ((100 - opacity) / 100)
            );
            document.body.style.setProperty(
                `--${prefix}-${opacity}`,
                this.rgbToHex(red, green, blue)
            );
        });
    }
}
